<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Προσθήκη υπηρεσίας</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Προσθήκη υπηρεσίας
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput label="Τίτλος" addLabelClasses="requiredLabel" type="text" id="name" placeholder="Τίτλος" v-model="name" horizontal></CInput>
              <CInput label="Standard name (IAF)" type="text" id="iaf_title" placeholder="Standard name (IAF)" v-model="iaf_title" horizontal></CInput>
              <CInput label="Scheme Name" type="text" id="scheme_name" placeholder="Scheme Name" v-model="scheme_name" horizontal></CInput>
              <CInput label="Πρόθεμα IAF" type="text" id="iaf_prefix" placeholder="Πρόθεμα IAF" v-model="iaf_prefix" horizontal></CInput>
              <div class="form-group form-row">
                <CCol tag="label" sm="3" class="col-form-label">Ομάδα</CCol>
                <CCol sm="9">
                  <div class="d-flex">
                    <select class="form-control mr-2" v-model="group_id">
                      <option value="">-- Επιλέξτε ομάδα --</option>
                      <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
                    </select>
                    <CButton color="success" size="sm" @click="showNewGroupModal = true" title="Νέα ομάδα">+</CButton>
                  </div>
                </CCol>
              </div>
              <CInput label="Κωδικός" addLabelClasses="requiredLabel" type="text" id="case_code_prefix" placeholder="Κωδικός" v-model="case_code_prefix" horizontal></CInput>
              <CTextarea id="description" addLabelClasses="requiredLabel" label="Περιγραφή" placeholder="Περιγραφή" v-model="description" horizontal></CTextarea>

            <!-- New Group Modal -->
            <CModal :show.sync="showNewGroupModal" :centered="true" title="Νέα Ομάδα">
              <CInput label="Όνομα Ομάδας" v-model="newGroupName" placeholder="π.χ. ISO 17021-1" />
              <template #footer>
                <CButton color="secondary" @click="showNewGroupModal = false">Ακύρωση</CButton>
                <CButton color="primary" @click="createGroup">Δημιουργία</CButton>
              </template>
            </CModal>
            <CButton color="primary" @click="store()">Δημιουργία</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
export default {
  name: 'CreateService',
  props: {
    caption: {
      type: String,
      default: 'Create Service'
    },
  },
  data: () => {
    return {
        name: '',
        iaf_title: '',
        scheme_name: '',
        iaf_prefix: '',
        group_id: '',
        groups: [],
        description: '',
        showMessage: false,
        message: '',
        case_code_prefix: '',
        dismissSecs: 7,
        alertIsShown: false,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        showNewGroupModal: false,
        newGroupName: ''
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/services'})
    },
    store() {
        let self = this;
        axios.post('/api/services?token=' + localStorage.getItem("api_token"),
        {
          name: self.name,
          iaf_title: self.iaf_title,
          scheme_name: self.scheme_name,
          iaf_prefix: self.iaf_prefix,
          group_id: self.group_id || null,
          description: self.description,
          case_code_prefix: self.case_code_prefix
        })
        .then(function (response) {
            self.name = '';
            self.iaf_title = '';
            self.scheme_name = '';
            self.iaf_prefix = '';
            self.group_id = '';
            self.description = '';
            self.case_code_prefix = '';
            self.message = 'Επιτυχής καταχώρηση υπηρεσίας.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    loadGroups() {
      let self = this;
      axios.get('/api/service-groups?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          self.groups = response.data.groups || [];
        }).catch(function (error) {
          console.log(error);
        });
    },
    createGroup() {
      let self = this;
      if (!self.newGroupName.trim()) return;
      axios.post('/api/service-groups?token=' + localStorage.getItem("api_token"), {
        name: self.newGroupName
      })
        .then(function (response) {
          self.groups.push(response.data);
          self.group_id = response.data.id;
          self.newGroupName = '';
          self.showNewGroupModal = false;
        }).catch(function (error) {
          console.log(error);
          if (error.response && error.response.data.errors) {
            alert(error.response.data.errors.name[0]);
          }
        });
    }
  },
  mounted: function(){
    this.loadGroups();
  }
}

</script>
